NtechApp.FormDataParser = function() {
    var me = this;

    this._$formToProcess = null;
    this._formJson = {};

    this._css = {
        ids: {},
        classes: {}
    }

    this._construct = function () {
        me._bindEvents();
    }

    this._bindEvents = function () {
    }

    this._unbindEvents = function () {
        ;
    }

    this.destruct = function () {
        me._unbindEvents();
    }

    this._construct();
    return this;
};

NtechApp.FormDataParser.prototype.getFormJSON = function($form) {
    this._formJson = {};
    this._$formToProcess = $form;

    this._convertAllFormFieldsToJSON();
    return this._formJson;
};

NtechApp.FormDataParser.prototype._convertAllFormFieldsToJSON = function() {
    this._convertTextInputs();
    this._convertNumberInputs();
    this._convertHiddenInputs();
    this._convertTelInputs();
    this._convertPasswordInputs();
    this._convertCheckboxInputs();
    this._convertRadioInputs();
    this._convertSelects();
    this._convertTextareas();
};

NtechApp.FormDataParser.prototype._convertTextInputs = function() {
    var me = this;
    this._$formToProcess.find("input[type='text']").each(function() {
        me._convertInputs($(this), $(this).val());
    });
};

NtechApp.FormDataParser.prototype._convertNumberInputs = function() {
    var me = this;
    this._$formToProcess.find("input[type='number']").each(function() {
        me._convertInputs($(this), $(this).val());
    });
};

NtechApp.FormDataParser.prototype._convertTelInputs = function() {
    var me = this;
    this._$formToProcess.find("input[type='tel']").each(function() {
        var val = $(this).val().replace(/[^\d]/g, '');
        me._convertInputs($(this), val);
    });
};

NtechApp.FormDataParser.prototype._convertHiddenInputs = function() {
    var me = this;
    this._$formToProcess.find("input[type='hidden']").each(function() {
        me._convertInputs($(this), $(this).val());
    });
};

NtechApp.FormDataParser.prototype._convertPasswordInputs = function() {
    var me = this;
    this._$formToProcess.find("input[type='password']").each(function() {
        me._convertInputs($(this), $(this).val());
    });
};

NtechApp.FormDataParser.prototype._convertCheckboxInputs = function() {
    var me = this;
    this._$formToProcess.find("input[type='checkbox']:checked").each(function() {
        me._convertInputs($(this), $(this).val());
    });
};

NtechApp.FormDataParser.prototype._convertRadioInputs = function() {
    var me = this;
    this._$formToProcess.find("input[type='radio']:checked").each(function() {
        me._convertInputs($(this), $(this).val());
    });
};

NtechApp.FormDataParser.prototype._setInputVal = function(field, accessor, nextAccessor) {
    if(typeof(nextAccessor) != "undefined" && NtechApp.isNumeric(nextAccessor)) {
        if(typeof field[accessor] != "undefined") {
            if(nextAccessor in field[accessor])
                return;
        }

        if(NtechApp.isNumeric(nextAccessor)) {
            if(typeof field[accessor] == "undefined")
                field[accessor] = [];

            for(var i = 0; i < nextAccessor; i++) {
                if(typeof field[accessor][i] == "undefined")
                    field[accessor][i] = {};
            }

            field[accessor][nextAccessor] = {};
        }

        //if(parseInt(nextAccessor, 10) == 0) {
        //    field[accessor] = [];
        //    field[accessor][0] = {};
        //}
        //else {
        //    // Fix for deleted collection rows
        //    if(typeof field[accessor] == "undefined")
        //        field[accessor] = [];
        //    field[accessor][nextAccessor] = {};
        //}
    }
    else  {
        if(!NtechApp.dom.hasOwnProp(field, accessor))
            field[accessor] = {};
    }
};

NtechApp.FormDataParser.prototype._convertInputs = function($input, inputValue) {
    var me = this;
    var inputNameAttr = $input.attr("name");

    var nameValRegex = /(.*?)\[(.*)\]/;
    if(nameValRegex.test(inputNameAttr)) {
        var matches = inputNameAttr.match(nameValRegex);
        var inputName = matches[1];
        var props = matches[2]; 

        props = props.split("[");
        for(var i = 0; i < props.length; i++) {
            props[i] = props[i].replace("[", "");
            props[i] = props[i].replace("]", "");
        }

        //var accessor = inputName;
        var accessor = props[0];
        //if(!NtechApp.dom.hasOwnProp(me._formJson, accessor))
        //    me._formJson[accessor] = {};
        me._setInputVal(me._formJson, accessor, props[1]);
        var field = me._formJson;

        for(var i = 1; i < props.length; i++) {
            var field = field[accessor];
            accessor = props[i];

            if(NtechApp.isNumeric(accessor))
                continue;

            var nextAccessor = props[i + 1];
            me._setInputVal(field, accessor, nextAccessor);
        }

        field[accessor] = inputValue;
    }
    else {
        if(NtechApp.isDev)
            console.log("Form builder can't parse input name: '" + inputNameAttr + "'");
    }
};

// Deprecated, form item names parser should parse Symfony collection prototypes
//NtechApp.FormDataParser.prototype._convertInputs = function($input, inputValue) {
//    var me = this;
//    var inputName = $input.attr("name");
//
//    var singleNameRegex = /\[(.*)\]/;
//    var doubleNameRegex = /\[(.*)\]\[(.*)\]/;
//
//    if(doubleNameRegex.test(inputName)) {
//        var matches = inputName.match(doubleNameRegex);
//
//        if(typeof me._formJson[matches[1]] == "undefined")
//            me._formJson[matches[1]] = {};
//
//        if(matches[2].length == 0) {
//            var nextPropertyName = "value" + me._generateNextPropertyNameIndex(matches[1]);
//            me._formJson[matches[1]][nextPropertyName] = inputValue;
//        }
//        else
//            me._formJson[matches[1]][matches[2]] = inputValue;
//    }
//    else if(singleNameRegex.test(inputName)) {
//        var matches = inputName.match(singleNameRegex);
//        me._formJson[matches[1]] = inputValue;
//    }
//    else {
//        if(NtechApp.isDev)
//            console.log("Form builder can't parse input name: '" + inputName + "'");
//    }
//};

// Deprecated, form item names contains indexes
//NtechApp.FormDataParser.prototype._generateNextPropertyNameIndex = function(objectPropertyName) {
//    var maxPropertyIndex = 0;
//    for(var propertyName in this._formJson[objectPropertyName])
//    {
//        var matches = propertyName.match(/(\d+)/);
//        var propertyIndex = matches[1];
//
//        if(propertyIndex > maxPropertyIndex)
//            maxPropertyIndex = propertyIndex;
//    }
//
//    return ++maxPropertyIndex;
//};

NtechApp.FormDataParser.prototype._convertSelects = function() {
    var me = this;
    this._$formToProcess.find("select").each(function() {
        var $select = $(this);
        var selectedValues = $(this).val();

        if(selectedValues != null && selectedValues.length > 0)
        {
            if(selectedValues.length == 1 || typeof(selectedValues) == "string")
            {
                var selectedValue = selectedValues;

                if($.isArray(selectedValue))
                    selectedValue = selectedValue[0];

                me._convertInputs($select, selectedValue);
            }
            else
            {
                $.each(selectedValues, function(key, selectedValue) {
                    me._convertInputs($select, selectedValue);
                });
            }
        }
    });
};

NtechApp.FormDataParser.prototype._convertTextareas = function() {
    var me = this;
    this._$formToProcess.find("textarea").each(function() {
        me._convertInputs($(this), $(this).val());
    });
};